import React, { useEffect, useState } from "react";
import "./Booking.scss";
import { navigate } from "gatsby";
import { BsChevronUp } from "react-icons/bs";
import Steps from "./Steps/Steps";
import Step2 from "./Step2/Step2";
import Ticket from "./Ticket/Ticket";
import SubmitButton from "./SubmitButton/SubmitButton";
import { isMobile } from "react-device-detect";
// import { withPrefix } from "gatsby";
import Step1 from "./Step1/Step1";
import Step3 from "./Step3/Step3";
import { isOffert, sumOfWindows } from "../../helpers/bookingUtils";
import { sendBookingEmail } from "../../helpers/emails";

const Booking = ({ finishBookingStep, setFinishBookingStep, ...props }) => {
  const [date, setDate] = useState();
  const [ticketVisible, setTicketVisible] = useState(false);
  const [price, setPrice] = useState(0);
  const [postNumber, setPostNumber] = useState("");

  //user
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [mobileNumber, setMobileNumber] = useState("");
  const [address, setAddress] = useState("");
  const [ort, setOrt] = useState("");
  const [personNumber, setPersonNumber] = useState();
  const [notes, setNotes] = useState("");
  const [leftKeyAtOffice, setLeyKeyAtOffice] = useState(false);

  const [windows, setWindows] = useState({
    1: 0,
    2: 0,
    4: 0,
    6: 0,
    8: 0,
    other: 0,
  });
  const [howOften, setHowOften] = useState("Engångsputs");
  const [windowsPages, setWindowsPages] = useState(null);
  const [optional, setOptional] = useState([]);

  const scrollToTop = () => {
    window.scrollTo(0, 0);
  };

  useEffect(() => {
    if (sumOfWindows(windows) === 0) {
      setPrice(0);
      return;
    }
    let newPrice = 410;
    newPrice += windows["1"] * 15;
    newPrice += windows["2"] * 25;
    newPrice += windows["4"] * 30;
    newPrice += windows["6"] * 30;
    newPrice += windows["8"] * 35;

    if (howOften !== "Putso - Ja" && howOften !== "Anpassad") {
      setPrice(newPrice);
    }

    if (howOften === "Två gånger per år") {
      newPrice = newPrice * 0.95;
      setPrice(newPrice);
    }

    if (howOften === "Putso Plus - Nej") {
      newPrice = newPrice / 2;
      setPrice(newPrice);
    }

    if (windowsPages === 4) {
      let windowsPagesPrice = 0;
      windowsPagesPrice += windows["1"] * 8;
      windowsPagesPrice += windows["2"] * 11;
      windowsPagesPrice += windows["4"] * 26;
      windowsPagesPrice += windows["6"] * 21;
      windowsPagesPrice += windows["8"] * 30;
      setPrice((p) => p + windowsPagesPrice);
    }

    if (optional.some((el) => el === "Karmtvätt")) {
      let optionalPrice = sumOfWindows(windows) * 46;
      setPrice((p) => p + optionalPrice);
    }

    if (optional.some((el) => el === "Fönsterbleck")) {
      let optionalPrice = sumOfWindows(windows) * 6;
      setPrice((p) => p + optionalPrice);
    }
  }, [windows, howOften, optional, windowsPages]);

  const finishBooking = () => {
    sendBookingEmail(
      navigateToSuccessPage,
      windows,
      howOften,
      windowsPages,
      optional,
      date,
      leftKeyAtOffice,
      firstName,
      lastName,
      email,
      mobileNumber,
      address,
      postNumber,
      ort,
      personNumber,
      notes,
      price
    );
  };

  const navigateToSuccessPage = () => {
    navigate("/thank-you");
  };

  return (
    <>
      <div className={"Booking finish"} id="booking">
        {/* {!loading && finishBookingStep >= 2 && ( */}
        <div className="finish-booking">
          <div className="left">
            <Steps step={finishBookingStep} />
            <div className="step-content">
              {finishBookingStep === 1 && (
                <Step1
                  onSubmit={() => {
                    if (isMobile) {
                      props.setAbleToGoBack(true);
                    }
                    setFinishBookingStep(2);
                    scrollToTop();
                  }}
                  price={price}
                  setPrice={setPrice}
                  howOften={howOften}
                  setHowOften={setHowOften}
                  windowsPages={windowsPages}
                  setWindowsPages={setWindowsPages}
                  optional={optional}
                  setOptional={setOptional}
                  windows={windows}
                  setWindows={setWindows}
                />
              )}
              {finishBookingStep === 2 && (
                <Step2
                  onSubmit={() => {
                    setFinishBookingStep(3);
                    scrollToTop();
                  }}
                  onBack={() => setFinishBookingStep(1)}
                  date={date}
                  setDate={setDate}
                  price={price}
                  setPrice={setPrice}
                  leftKeyAtOffice={leftKeyAtOffice}
                  setLeyKeyAtOffice={setLeyKeyAtOffice}
                  isOffert={isOffert(windows, howOften, optional)}
                />
              )}
              {finishBookingStep === 3 && (
                <>
                  <Step3
                    onBack={() => {
                      setFinishBookingStep(2);
                      scrollToTop();
                    }}
                    onSubmit={finishBooking}
                    postNumber={postNumber}
                    setPostNumber={setPostNumber}
                    firstName={firstName}
                    setFirstName={setFirstName}
                    lastName={lastName}
                    setLastName={setLastName}
                    email={email}
                    setEmail={setEmail}
                    address={address}
                    setAddress={setAddress}
                    ort={ort}
                    mobileNumber={mobileNumber}
                    setMobileNumber={setMobileNumber}
                    setOrt={setOrt}
                    notes={notes}
                    setNotes={setNotes}
                    personNumber={personNumber}
                    setPersonNumber={setPersonNumber}
                  />
                  <div className="last-step-summary">
                    <div className="divider" />
                    <Ticket
                      date={date}
                      step={finishBookingStep}
                      postNumber={postNumber}
                      address={address}
                      price={price}
                      ort={ort}
                      windows={windows}
                      howOften={howOften}
                      windowsPages={
                        howOften === "Engångsputs" ||
                        howOften === "Två gånger per år"
                          ? windowsPages
                          : null
                      }
                      optional={optional}
                    />
                  </div>
                  <div className="confirm-info info-2 white-shadow">
                    <p className="description" style={{ margin: 0 }}>
                      Genom att klicka på “Skicka bokningsförfråga” godkänner
                      jag Putsos{" "}
                      <a
                        href={`/integritets-och-cookiespolicy`}
                        target="_blanko"
                        rel="noopener noreferrer"
                      >
                        integritetspolicy.
                      </a>
                    </p>
                  </div>
                </>
              )}
            </div>
          </div>
          <div className="right">
            <Ticket
              date={date}
              step={finishBookingStep}
              postNumber={postNumber}
              address={address}
              price={price}
              ort={ort}
              windows={windows}
              howOften={howOften}
              windowsPages={
                howOften === "Engångsputs" || howOften === "Två gånger per år"
                  ? windowsPages
                  : null
              }
              optional={optional}
            />
          </div>
          <div className={"ticket" + (ticketVisible ? " active" : "")}>
            <div className="inner">
              <Ticket
                date={date}
                step={finishBookingStep}
                postNumber={postNumber}
                address={address}
                price={price}
                ort={ort}
                windows={windows}
                howOften={howOften}
                windowsPages={
                  howOften === "Engångsputs" || howOften === "Två gånger per år"
                    ? windowsPages
                    : null
                }
                optional={optional}
              />
              <div className="divider" />
            </div>
          </div>
          <div className="mobile-bottom">
            {!ticketVisible && (
              <div
                className="see-ticket"
                onClick={() => {
                  setTicketVisible(true);
                  scrollToTop();
                }}
                aria-hidden="true"
              >
                <p>Se sammanfattning</p>
                <BsChevronUp />
              </div>
            )}
            <div className="price-fixed">
              {ticketVisible && (
                <SubmitButton
                  mobile
                  closeTicket
                  isValid={true}
                  text="Göm sammanfattning"
                  onClick={() => setTicketVisible(false)}
                />
              )}
              {!ticketVisible && (
                <>
                  <div className="price-left">
                    <h3>
                      {isOffert(windows, howOften, optional)
                        ? "Offert"
                        : `${parseInt(price)} kr`}
                    </h3>
                    {/* <p>efter RUT</p> */}
                  </div>
                  {finishBookingStep === 1 && (
                    <SubmitButton
                      mobile
                      isValid={
                        sumOfWindows(windows) !== 0 &&
                        optional?.length > 0 &&
                        windowsPages
                      }
                      text="Välj datum"
                      onClick={() => {
                        setFinishBookingStep(2);
                        scrollToTop();
                        props.setAbleToGoBack(true);
                      }}
                    />
                  )}
                  {finishBookingStep === 2 && (
                    <SubmitButton
                      mobile
                      text="Fortsätt"
                      isValid={date}
                      onClick={() => {
                        setFinishBookingStep(3);
                        scrollToTop();
                      }}
                    />
                  )}
                  {finishBookingStep === 3 && (
                    <SubmitButton
                      mobile
                      text="Skicka bokningsförfråga"
                      isValid={
                        firstName !== "" &&
                        lastName !== "" &&
                        email !== "" &&
                        mobileNumber !== "" &&
                        address !== "" &&
                        ort !== ""
                      }
                      onClick={finishBooking}
                    />
                  )}
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Booking;
